import { ReactElement } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import Can from '../../../components/Can';
import { isMobile } from 'react-device-detect';
import { useStores } from '../../../stores';
import ScheduleWeekActionsMenu from './ScheduleWeekActionsMenu';
import ScheduleCreateEntryMenu from './ScheduleCreateEntryMenu';

interface Props {
    onExcelDownload: () => void;
    onEpubUpload: () => void;
    onScheduleWeekCreate: () => void;
    onScheduleWeekEdit: () => void;
    onScheduleWeekDelete: () => void;
    onCreateScheduleEntry: () => void;
    onCreateFieldServiceEntry: () => void;
    onCreateSpeechEntry: () => void;
}

const SchedulePageMenu = (props: Props) => {
    const { t } = useTranslation();
    const { scheduleStore } = useStores();

    const headerItems = () => {
        const items: ReactElement[] = [];

        if (!isMobile) {
            items.push(
                <Can key="download_excel_schedule" do="manage" on='ScheduleWeek'>
                    <Button color="inherit" type="button" onClick={props.onExcelDownload}>
                        {t("download_excel")}
                    </Button>
                </Can>
            );

            items.push(
                <Can key="import_epub_btn" do="manage" on='ScheduleEntry'>
                    <Button color="inherit" type="button" onClick={props.onEpubUpload}>
                        {t("import_epub")}
                    </Button>
                </Can>
            );
        }

        const hasCurrentWeek = Boolean(scheduleStore.currentWeek);
        const canModifyWeek = Boolean(scheduleStore.currentWeek?.id);

        items.push(
            <Can key="week_actions" do="manage" on='ScheduleWeek'>
                <ScheduleWeekActionsMenu
                    onCreate={props.onScheduleWeekCreate}
                    onEdit={props.onScheduleWeekEdit}
                    onDelete={props.onScheduleWeekDelete}
                    disableCreate={hasCurrentWeek}
                    disableModify={!canModifyWeek}
                />
            </Can>
        );

        items.push(
            <Can key="create_entry-btn" do="manage" on='ScheduleEntry'>
                <ScheduleCreateEntryMenu
                    onCreateScheduleEntry={props.onCreateScheduleEntry}
                    onCreateFieldServiceEntry={props.onCreateFieldServiceEntry}
                    onCreateSpeechEntry={props.onCreateSpeechEntry}
                    disableSpeech
                />
            </Can>
        );

        return items;
    };

    return headerItems();
};

export default SchedulePageMenu;
